import { render, staticRenderFns } from "./questCenter.vue?vue&type=template&id=1c719ee2&scoped=true"
import script from "./questCenter.vue?vue&type=script&lang=js"
export * from "./questCenter.vue?vue&type=script&lang=js"
import style0 from "./questCenter.vue?vue&type=style&index=0&id=1c719ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c719ee2",
  null
  
)

export default component.exports